import React from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import Transactions from "us.collection.transactions";
import { INavigationData } from 'us.collection/interfaces';

interface ICnt_ApplicableCourts {
    caseNo: number;
}

const Cnt_ApplicableCourts: React.FC<ICnt_ApplicableCourts> = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as INavigationData;

    const onMinimize = (url: string) => {
        navigate(url, { state });
    }

    return (
        <Transactions.Components.ApplicableCourts onMinimize={() => onMinimize(`/case/${props.caseNo}`)} {...props} />

    )
}

export default Cnt_ApplicableCourts;
